import { createFileRoute } from '@tanstack/react-router';
import ReceptionPortal from '../../components/portals/ReceptionPortal';

export const Route = createFileRoute('/reception/_layout')({
  component: ReceptionPortal,
});

